import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";
import { HERO, PROFILE } from "../data";

const EASE = [0.22, 1, 0.36, 1];

export default function Hero() {
  const go = () => {
    const el = document.getElementById("contact");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  };

  return (
    <section id="top" className="relative pt-28 md:pt-32 pb-10 px-4 md:px-6">
      <div className="max-w-[1240px] mx-auto">
        <div className="card p-7 md:p-14 grid md:grid-cols-[1.15fr_0.85fr] gap-10 md:gap-14 items-center">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: EASE }}
              className="font-display text-ink-soft text-lg md:text-xl mb-4"
            >
              {HERO.greeting} —
            </motion.p>

            <h1 className="font-display font-semibold tracking-tight text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.06]">
              <MaskLines
                start={0.15}
                lines={[
                  "Product Manager with",
                  "5+ years of experience",
                  <span key="a">in <span className="text-accent">B2B SaaS</span> &</span>,
                  "Enterprise platforms.",
                ]}
              />
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.8, ease: EASE }}
              className="mt-7 text-ink-soft text-base md:text-lg leading-relaxed max-w-xl"
            >
              {HERO.sub}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.85, duration: 0.8, ease: EASE }}
              className="mt-9 flex flex-wrap items-center gap-3"
            >
              <button data-testid="hero-cta" onClick={go} className="btn-dark">
                Let's Connect
                <span aria-hidden>→</span>
              </button>
              <a data-testid="hero-calendly" href={PROFILE.calendly} target="_blank" rel="noreferrer" className="btn-ghost">
                Book a meeting
              </a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.35, duration: 1, ease: EASE }}
            className="relative"
          >
            <div className="overflow-hidden rounded-[28px] aspect-[4/5] bg-bg-dark">
              <img
                data-testid="hero-photo"
                src={PROFILE.photo}
                alt="Jesal Sharma"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
